export enum PromotionsTab {
  AllOffers = 'all-offers',
  ActiveBonuses = 'active-offers',
  BonusHistory = 'bonus-history',
}

export const ACTIVE_BONUSES_URL = `/bonuses?tab=${PromotionsTab.ActiveBonuses}`;
